import { createRandomId } from "./utils.mjs";
export const createActionMethods = (state, addAndProcessCommand) => {
    return {
        addCustomStickerLineItem(customStickerId, quantity) {
            return addAndProcessCommand({
                id: createRandomId(),
                command: 'addCustomStickerLineItem',
                customStickerId,
                quantity,
            });
        },
        addStickerShopLineItem(stickerShopItemId, quantity) {
            return addAndProcessCommand({
                id: createRandomId(),
                command: 'addStickerShopLineItem',
                stickerShopItemId,
                quantity,
            });
        },
        addStickerPackLineItem(stickerPackId, quantity) {
            return addAndProcessCommand({
                id: createRandomId(),
                command: 'addStickerPackLineItem',
                stickerPackId,
                quantity,
            });
        },
        addGiftCardLineItem(name, imageUrl, figureId, quantity = 1) {
            return addAndProcessCommand({
                id: createRandomId(),
                command: 'addGiftCardLineItem',
                name,
                imageUrl,
                figureId,
                quantity,
            });
        },
        removeLineItem(lineItemId) {
            return addAndProcessCommand({
                id: createRandomId(),
                command: 'removeLineItem',
                lineItemId,
            });
        },
        updateLineItem(lineItemId, quantity) {
            return addAndProcessCommand({
                id: createRandomId(),
                command: 'updateLineItem',
                lineItemId,
                quantity,
            });
        },
        duplicateCustomStickerLineItem(lineItemId, quantity) {
            return addAndProcessCommand({
                id: createRandomId(),
                command: 'duplicateCustomStickerLineItem',
                lineItemId,
                quantity,
            });
        },
        // TODO: we can retire this command 1 month after the release of our refactor (the-big-branch)
        addLinesFromOrder(orderId, sheetIds, email, transactionId, discountCode, isReorder) {
            return addAndProcessCommand({
                id: createRandomId(),
                command: 'addLinesFromOrder',
                orderId,
                sheetIds,
                email,
                transactionId,
                discountCode,
                isReorder,
            });
        },
        createCartFromManualOrder(orderId, sheetIds, email, transactionId, discountCode) {
            return addAndProcessCommand({
                id: createRandomId(),
                command: 'createCartFromManualOrder',
                orderId,
                sheetIds,
                email,
                transactionId,
                discountCode,
            });
        },
        selectShippingMethod(shippingMethodId) {
            return addAndProcessCommand({
                id: createRandomId(),
                command: 'selectShippingMethod',
                shippingMethodId,
            });
        },
        setBillingAddress(address) {
            return addAndProcessCommand({
                id: createRandomId(),
                command: 'setBillingAddress',
                address,
            });
        },
        setUseBillingAddress(useBillingAddress) {
            return addAndProcessCommand({
                id: createRandomId(),
                command: 'setUseBillingAddress',
                useBillingAddress,
            });
        },
        selectPaymentMethod(paymentMethodId) {
            return addAndProcessCommand({
                id: createRandomId(),
                command: 'selectPaymentMethod',
                paymentMethodId,
            });
        },
        addCode(discountOrGiftCardCode) {
            return addAndProcessCommand({
                id: createRandomId(),
                command: 'addCode',
                code: discountOrGiftCardCode,
            });
        },
        removeCode(discountOrGiftCardCode) {
            return addAndProcessCommand({
                id: createRandomId(),
                command: 'removeCode',
                code: discountOrGiftCardCode,
            });
        },
        setAddress(address) {
            return addAndProcessCommand({
                id: createRandomId(),
                command: 'setAddress',
                address,
            });
        },
        setEmail(email) {
            return addAndProcessCommand({
                id: createRandomId(),
                command: 'setEmail',
                email,
            });
        },
        setPhoneNumber(phoneNumber) {
            return addAndProcessCommand({
                id: createRandomId(),
                command: 'setPhoneNumber',
                phoneNumber,
            });
        },
        setCompanyName(companyName) {
            return addAndProcessCommand({
                id: createRandomId(),
                command: 'setCompanyName',
                companyName,
            });
        },
        setIsCompany(isCompany) {
            return addAndProcessCommand({
                id: createRandomId(),
                command: 'setIsCompany',
                isCompany,
            });
        },
        setVatNumber(vatNumber) {
            return addAndProcessCommand({
                id: createRandomId(),
                command: 'setVatNumber',
                vatNumber,
            });
        },
        setReference(reference) {
            return addAndProcessCommand({
                id: createRandomId(),
                command: 'setReference',
                reference,
            });
        },
        setComment(comment) {
            return addAndProcessCommand({
                id: createRandomId(),
                command: 'setComment',
                comment,
            });
        },
        setShout(orderId, handle, permission) {
            return addAndProcessCommand({
                id: createRandomId(),
                command: 'setShout',
                orderId,
                handle,
                permission,
            });
        },
        /**
         * This sends the full cart to the server to recover it. It should only be used when the server has lost the cart data.
         */
        recoverCart() {
            return addAndProcessCommand({
                id: createRandomId(),
                cart: state,
                command: 'recoverCart',
            });
        },
    };
};
//# sourceMappingURL=actionMethods.js.map